
import { TrialLicenseActions, TrialLicenseActionTypes } from '../actions/trial-license.actions';
import {LicenseMgtList, TrialLicensesMgt} from '../license-mgt.model';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entity: TrialLicensesMgt[];
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entity: []
};

export function reducer(state = initialState, action: TrialLicenseActions): State {
  switch (action.type) {
    case TrialLicenseActionTypes.GetTrialLicenses:
      return {...state, Loaded: false, Loading: true};
    case TrialLicenseActionTypes.GetTrialLicensesFail:
      return {...state, Loaded: true, Loading: false, entity: []};
    case TrialLicenseActionTypes.LoadTrialLicenses:
      return {...state, Loaded: true, Loading: false, entity: action.payload};

    default:
      return state;
  }
}
